module.exports = "pegasus_template/assets/themelp1/product/100.png";